import { render, staticRenderFns } from "./NadobudnutieWrapper.vue?vue&type=template&id=1bcb6997&scoped=true&"
import script from "./NadobudnutieWrapper.vue?vue&type=script&lang=js&"
export * from "./NadobudnutieWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NadobudnutieWrapper.vue?vue&type=style&index=0&id=1bcb6997&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb6997",
  null
  
)

export default component.exports